import React, { Component } from 'react';
import CalculatorRegularPayment from './CalculatorRegularPayment';
import HelperGenerics from '../../helpers/HelperGenerics';
import ContCalculatorCriteria from '../../containers/ContCalculatorCriteria';
import CalculatorContentCommon from './CalculatorContentCommon';

class CalculatorContentClassical extends Component {
    render() {
        return (
            <React.Fragment>
                <div className="row p-1 m-1">
                    <div className="col-12 col-md-6 col-lg-4 p-0">
                        <ContCalculatorCriteria />
                    </div>
                    <div className="col-12 col-md-6 col-lg-8 p-0">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-12 col-lg-5 order-lg-2 text-center">
                                    <div className="row shadow rounded m-auto">
                                        <CalculatorRegularPayment
                                            context={this.props.context}
                                            amountNature={this.props.amountNature}
                                            isCalculationResult={this.props.isCalculationResult}
                                            calculationResponse={this.props.calculationResponse}
                                            onUpdateCriteria={this.props.onUpdateCriteria}
                                        />
                                    </div>
                                    {this.props.isCalculationResult
                                        && this.props.calculationResponse.result.globalText
                                        && this.props.calculationResponse.result.globalText.detailInformationLink
                                        && <div className="row shadow rounded m-auto p-2">
                                            {HelperGenerics.renderLink(this.props.calculationResponse.result.globalText.detailInformationLink.href,
                                                null, this.props.calculationResponse.result.globalText.detailInformationLink.text, 'btn btn-link')}
                                        </div>
                                    }
                                </div>
                                <div className="col-12 col-lg-7 order-lg-1">
                                    {this.props.isCalculationResult
                                        && this.props.calculationResponse.result.globalText
                                        && this.props.calculationResponse.result.globalText.financialProductLabel
                                        &&
                                        <div className="row shadow rounded m-1 text-center"><h5>
                                            {this.props.calculationResponse.result.globalText.financialProductLabel.text}
                                        </h5>
                                        </div>
                                    }
                                    <div className="row p-2 m-0">
                                        {CalculatorContentCommon.renderDisplayBlocks(this.props.isCalculationResult, this.props.calculationResponse)}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <CalculatorContentCommon isCalculationResult={this.props.isCalculationResult} calculationResponse={this.props.calculationResponse}
                />
            </React.Fragment>
        );
    }
}

export default (CalculatorContentClassical)
